import React from "react";

import { siteConfig } from "config/config";

import SiteMetaData from "./SiteMetaData/SiteMetaData";

const SEO = ({ children, pageMetaData }) => {
  const { siteMetadata } = siteConfig;
  return (
    <>
      <SiteMetaData siteMetadata={siteMetadata} pageMetaData={pageMetaData} />
      {children}
    </>
  );
};

export default SEO;
